import { IconButton } from "@mui/material";
import styled from "styled-components";

export const IconButtonStyled=styled(IconButton)`

    background: rgba(51, 83, 178, 0.09) !important;

   &:hover {

         background: #e74c3c !important;
         color:#fff !important;
    }

`